/**
 * Creates an dom element with the given tag and atrributes. Said
 * element is not added to the document context and is returned
 * as is
 * @param  {string} tag
 * @param  {object.<string,string>} attributes
 * @return {HTMLElement}
 */
export function createElement(tag, attributes) {
    const elem = document.createElement(tag)
    for (let name in (attributes || {})) {
        let value = attributes[name];
        elem.setAttribute(name, value);
    }
    return elem;
}

/**
 * Creates a style element with the stylesheet own attributes element
 * plus given atrributes. Said element is not added to the document
 * context and is returned as is.
 *
 * @param  {object.<string,string>} attributes
 * @return {HTMLLinkElement}
 */
export function createStyleElement(attributes) {
    return createElement('style', Object.assign({
        type: 'text/css',
    }, attributes));
}

/**
 * Creates a link element with the stylesheet own attributes element
 * plus given atrributes. Said element is not added to the document
 * context and is returned as is.
 *
 * @param  {object.<string,string>} attributes
 * @return {HTMLLinkElement}
 */
export function createLinkStylesheetElement(attributes) {
    return createElement('link', Object.assign({
        type: 'text/css',
        rel: 'stylesheet',
    }, attributes));
}

/**
 * Creates a script element with the stylesheet own attributes element
 * plus given atrributes. Said element is not added to the document
 * context and is returned as is.
 *
 * @param  {object.<string,string>} attributes
 * @return {HTMLScriptElement}
 */
export function createScriptElement(attributes) {
    return createElement('script', Object.assign({
        type: 'text/javascript',
    }, attributes));
}



// WEBPACK FOOTER //
// ./src/shared/childupp-bootstrap/dom.js